// Defensive parser for the 'user' localStorage entry.
// If a non-JSON value somehow lands in localStorage.user (disk corruption,
// browser extension interference, manual tampering), returning an empty
// object keeps the React tree from crashing on app load.
// R109/Case-3 hardening (build #223).
export default function getStoredUser() {
  try {
    const raw = localStorage.getItem('user');
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return (parsed && typeof parsed === 'object') ? parsed : {};
  } catch {
    return {};
  }
}
